import * as React from 'react'
import { Field, FieldProps } from 'formik'
import { InputField } from '@espoon-voltti/react-components/elements/form'
import { fieldState, ErrorMessage } from '../formik-util'
import { InputProps } from './types'

export const FormField = (p: InputProps) => (
  <Field name={p.name}>
    {({ field, form }: FieldProps) => (
      <InputField
        {...field}
        required={p.required}
        type="text"
        label={p.label}
        dataQa={p.dataQa}
        state={fieldState(field.name, form)}
        message={<ErrorMessage name={field.name} />}
        placeholder={p.placeholder}
        disabled={p.disabled}
        maxLength={p.maxLength}
      />
    )}
  </Field>
)

interface HiddenInputProps {
  name: string
  dataQa: string
}

export const HiddenField: React.FunctionComponent<HiddenInputProps> = (p) => (
  <Field name={p.name}>
    {({ field }: FieldProps) => (
      <input type="hidden" data-qa={p.dataQa} {...field} />
    )}
  </Field>
)
